import React from 'react'

export default function AmlPolicy() {
  return (
    <div>AmlPolicy</div>
  )
}
